import * as supplierUrlJson from "./supplierUrl.json";

export const supplierUrl = supplierUrlJson;
